// @ts-nocheck


import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { TabItem } from '../../../components/ui';
import MonthDailyBudgetTable from './MonthDailyBudgetTable';
import YearDailyBudgetTable from './YearDailyBudgetTable';
import { StyledTabs } from './elements';
import { connect } from 'react-redux';


import { showMonthPlan, showYearPlan } from './lib';
import { RouteComponent } from '../../../lib/routerAdapter';






/**
 * Планирование лимитных дней на год и месяц
 */
const DailyBudgets = ({ userAccess, orgUnitId }) => {
  const canViewYearPlan = showYearPlan(userAccess);
  const canViewMonthPlan = showMonthPlan(userAccess);

  return (
    <>
      <StyledTabs background="#F0F4F8" defaultTab="year" withRouter>
        {canViewYearPlan &&
        <TabItem
          label="Годовой план"
          url="/contract-vehicle-work-plans/daily-budgets" />

        }
        {canViewMonthPlan &&
        <TabItem
          label="Месячный план"
          url="/contract-vehicle-work-plans/daily-budgets/month/" />

        }
      </StyledTabs>
      <Routes>
        {canViewYearPlan &&
        <Route
          index
          element={
          <RouteComponent
            component={YearDailyBudgetTable}
            orgUnitId={orgUnitId} />

          } />

        }
        {canViewMonthPlan &&
        <Route
          path="month"
          element={
          <RouteComponent
            component={MonthDailyBudgetTable}
            orgUnitId={orgUnitId} />

          } />

        }
      </Routes>
    </>);

};

export default connect((state) => ({
  userAccess: state.auth.profile.access
}))(DailyBudgets);
